import React from 'react';
import './ChristmasDecorations.css';

const ChristmasDecorations = () => {
  return (
    <>
      {/* Santa Claus - Bottom Right */}
      <div className="santa-container">
        <div className="santa">
          <div className="santa-hat">
            <div className="hat-base"></div>
            <div className="hat-tip"></div>
            <div className="hat-pom"></div>
          </div>
          <div className="santa-face">
            <div className="santa-eyes">
              <div className="santa-eye left"></div>
              <div className="santa-eye right"></div>
            </div>
            <div className="santa-nose"></div>
            <div className="santa-cheeks">
              <div className="cheek left"></div>
              <div className="cheek right"></div>
            </div>
            <div className="santa-mustache">
              <div className="mustache-part left"></div>
              <div className="mustache-part right"></div>
            </div>
            <div className="santa-beard"></div>
          </div>
          <div className="santa-body">
            <div className="santa-suit"></div>
            <div className="santa-belt">
              <div className="belt-buckle"></div>
            </div>
          </div>
          <div className="santa-wave">👋</div>
        </div>
        <div className="santa-speech">Ho Ho Ho!</div>
      </div>

      {/* Snowman - Bottom Left */}
      <div className="snowman-container">
        <div className="snowman">
          <div className="snowman-hat">
            <div className="hat-brim"></div>
            <div className="hat-top"></div>
          </div>
          <div className="snowman-head">
            <div className="snowman-eyes">
              <div className="coal-eye"></div>
              <div className="coal-eye"></div>
            </div>
            <div className="carrot-nose"></div>
            <div className="snowman-smile">
              <div className="coal-smile"></div>
              <div className="coal-smile"></div>
              <div className="coal-smile"></div>
              <div className="coal-smile"></div>
              <div className="coal-smile"></div>
            </div>
          </div>
          <div className="snowman-body">
            <div className="coal-button"></div>
            <div className="coal-button"></div>
            <div className="coal-button"></div>
            <div className="snowman-scarf">
              <div className="scarf-wrap"></div>
              <div className="scarf-tail"></div>
            </div>
          </div>
          <div className="snowman-base"></div>
          <div className="snowman-arms">
            <div className="arm left">
              <div className="stick"></div>
              <div className="twig"></div>
              <div className="twig"></div>
            </div>
            <div className="arm right">
              <div className="stick"></div>
              <div className="twig"></div>
              <div className="twig"></div>
            </div>
          </div>
        </div>
        <div className="snow-pile"></div>
      </div>
    </>
  );
};

export default ChristmasDecorations;
